<template>
  <CommonPages id="about" class="about common-text" headerTheme="dark" titlePrefix="About Us">
    <div class="common-text__container">
      <div class="common-text__content pc_padding">
        <h1 class="common-text__title">About Us</h1>

        <div class="common-text__section">
          <p class="common-text__paragraph">
            Welcome to Car and Driver. We've created this page to introduce ourselves to you and to
            let you know what it is we do around here. Car and Driver is a print and digital
            magazine covering the newest car offerings, showcasing car culture, and helping people
            shopping for a car by serving up our unique brand of intelligence, independence, and
            irreverence. We've been in the magazine business since 1955 and online for more than two
            decades.
            <br><br>
            We make the complicated easier to understand for those of you shopping for a new car and
            push the limits of performance machines for our enthusiast readers. A Car and
            Driver review balances the subjective with objective data and pulls no punches; on our
            best days, we hope we even give you a good laugh. We pull together multi-car comparison
            tests that separate the good, the bad, and the ugly to give you the product knowledge
            that you crave. Our online ranking system breaks down vehicle segments to help shoppers
            make informed decisions. In addition to sharp and unbiased reviews, our features and
            columns allow our readers to ride shotgun with the world's finest automotive writers.
            <br><br>

            Like vinyl records, the print version of Car and Driver is on trend, collectible, and
            never goes out of style. In each issue, you'll get the very best from our writers,
            photographers, and graphic artists in a format you can hold in your hands. It's also the
            only place to get our legendary Backfires column, where you can read the best (and
            worst) letters to the editor and Ed.'s responses. Do what legions of discerning readers
            have been doing since 1955 and subscribe to Car and Driver.
            <br><br>

            We're also in the business of testing cars, trucks, SUVs, and vans. That's what
            separates us from other automotive media. For more than 60 years we've been answering
            the objective questions—How fast? How quick? How much grip?—and our findings have
            settled countless barroom bets. With the goal of covering every make and model on the
            market, we test upward of 400 vehicles per year, more than anyone else in the industry.
            In the early days of the magazine, just as the interstate highway system began to
            connect the country, we used a stopwatch to measure acceleration times. Today, we use
            highly precise GPS-based testing equipment. Testing is continually evolving as
            technology and vehicles change. Recently we've added several static tests to measure
            cargo space, interior stowage pockets, infotainment response time, and the size of blind
            spots, among other things. In all, we collect more than 200 data points on every test
            vehicle. You can learn more about our tests and procedures here.
            <br><br>

            Why put so much energy into vehicle testing? We believe that third-party testing is
            critical because manufacturers' performance claims are just that: claims. Over the
            years, C/D testing has uncovered numerous cars that didn't perform as promised. In 1999,
            our test of an underperforming Ford Mustang Cobra led Ford to admit that defective
            intake manifolds were compromising airflow. Ford installed new intake manifolds and
            mufflers to deliver the promised horses. When a 2001 Mazda Miata proved slower than the
            outgoing model despite a claimed 15-horsepower increase, we called BS. Mazda then
            confessed that the 155-horsepower number came from a Japanese version that didn't pass
            U.S. emission standards. Mazda offered to buy back early models or provide free
            maintenance and $500. More recently, Toyota claimed that the 2020 Supra's center of
            gravity was lower than the GR86's, so we measured that. Toyota was wrong.
            <br><br>

            Car and Driver is partly supported by advertising, but everything you see on the site or
            in the magazine is produced by our editors or contributors and adheres to our high
            standards for quality. To ensure accuracy, our content is fact-checked by the copy
            department and edited by the testing team to verify technical accuracy. If we do have
            any content created in partnership with advertisers, we will mark it as such. And we
            value your contribution as well: let us know if you spot an error or have feedback you
            want to share.
          </p>

        </div>

        <div class="about-car-list">
          <div class="about-car-item" v-for="i in 12" :key="i">
            <img :src="require(`@/assets/about/item-${i}.png`)" alt="">
          </div>
        </div>

      </div>
    </div>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'

export default {
  name: 'Privacy',
  components: {
    CommonPages
  },
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.common-text {
	background: #fff;
	min-height: 100vh;

	.about-car-list {
		display: flex;
		flex-wrap: wrap;
		row-gap: rem(16);
		column-gap: rem(14);
		margin-top: rem(40);
		.about-car-item {
			flex: 0 0 calc((100% - rem(70)) / 6); /* 使每个子元素占1/3的宽度 */
		}
	}

	&__content {
		margin: 0 auto;
		padding: rem(60) rem(120);
		width: 100%;
	}

	&__title {
		color: #141414;

		font-size: rem(24);
		font-weight: 700;
		line-height: rem(24);
		margin-bottom: rem(24);
	}

	&__section {
		margin-bottom: rem(40);
	}

	&__section-title {
		color: #141414;

		font-size: rem(24);
		font-weight: 700;
		line-height: rem(28);
		margin-bottom: rem(16);
	}

	&__subsection-title {
		color: #141414;

		font-size: rem(18);
		font-weight: 600;
		line-height: rem(24);
		margin-top: rem(20);
		margin-bottom: rem(12);
	}

	&__paragraph {
		color: #777;

		font-size: rem(12);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
	}

	&__link {
		color: var(--theme-color);
		text-decoration: underline;
		text-decoration-thickness: auto;
		text-decoration-style: solid;
		text-decoration-skip-ink: none;

		&:hover {
			opacity: 0.8;
		}
	}

	&__list,
	&__numbered-list {
		color: #777;

		font-size: rem(14);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
		padding-left: rem(20);
	}

	&__list {
		list-style-type: disc;
	}

	&__numbered-list {
		list-style-type: decimal;
	}

	&__list-item,
	&__numbered-list-item {
		margin-bottom: rem(8);

		&:last-child {
			margin-bottom: 0;
		}
	}

	&__table {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: rem(20);

		font-size: rem(14);

		th,
		td {
			border: 1px solid #e9e9e9;
			padding: rem(10) rem(16);
			text-align: left;
		}

		th {
			background-color: #f5f7fa;
			color: #141414;
			font-weight: 600;
		}

		td {
			color: #777;
		}
	}

	&__blockquote {
		border-left: 4px solid #405ff2;
		padding: rem(16) rem(20);
		background-color: #f5f7fa;
		margin: rem(16) 0;
		color: #777;

		font-size: rem(14);
		font-style: italic;
		line-height: rem(24);
	}

	&__code-block {
		background-color: #f5f7fa;
		border-radius: rem(8);
		padding: rem(16);
		margin: rem(16) 0;
		overflow-x: auto;

		pre {
			margin: 0;

			code {
				color: #777;
				font-size: rem(14);
				line-height: 1.5;
			}
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.common-text {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);

		&__title {
			font-size: rem(24);
			line-height: rem(24);
		}

		&__section-title {
			font-size: rem(16);
			line-height: rem(24);
		}
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.about-car-list {
		display: flex;
		flex-wrap: wrap;
		row-gap: rem(16);
		column-gap: rem(1);
		margin-top: rem(1);
		.about-car-item {
			flex: 0 0 calc((100% - rem(1)) / 2); /* 使每个子元素占1/3的宽度 */
		}
	}
	.common-text {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);

		&__content {
			padding: 0 rem(16);
		}

		&__content {
			max-width: rem(343);
			padding: rem(20);
		}

		&__title {
			font-size: rem(24);
			line-height: rem(24);
			margin-bottom: rem(20);
		}

		&__section-title {
			font-size: rem(16);
			font-style: normal;
			font-weight: 900;
			line-height: rem(24); /* 150% */
			margin-bottom: rem(8);
		}

		&__subsection-title {
			color: #141414;

			font-size: rem(12);
			font-weight: 600;
			line-height: rem(24);
			margin-top: rem(16);
			margin-bottom: rem(8);
		}

		&__paragraph {
			color: #777;

			font-size: rem(12);
			font-weight: 400;
			line-height: rem(24);
			margin-bottom: rem(8);
		}

		&__list,
		&__numbered-list {
			font-size: rem(12);
			line-height: rem(24);
			margin-bottom: rem(12);
		}

		&__list-item,
		&__numbered-list-item {
			margin-bottom: rem(6);
		}

		&__blockquote {
			font-size: rem(12);
			padding: rem(12) rem(16);
			margin: rem(12) 0;
		}

		&__table {
			font-size: rem(12);

			th,
			td {
				padding: rem(8) rem(12);
			}
		}
	}
}
</style>